/* Nema Firenze - Hero logo scroll shrink animation */
(function() {
  'use strict';

  var logo = document.querySelector('[id*="section_Fh7TFQ"] .logo-block__image');
  var heroSection = document.querySelector('[id*="section_Fh7TFQ"]');

  if (!logo || !heroSection) return;

  var heroHeight = heroSection.offsetHeight;
  var minScale = 0.3;
  var maxScale = 1;
  var ticking = false;

  function updateLogo() {
    var scrollY = window.pageYOffset || document.documentElement.scrollTop;
    var progress = Math.min(scrollY / heroHeight, 1);

    var scale = maxScale - (progress * (maxScale - minScale));
    var opacity = 1 - (progress * 0.6);

    logo.style.transform = 'scale(' + scale + ')';
    logo.style.opacity = opacity;
    ticking = false;
  }

  /* Set transform origin to center */
  logo.style.transformOrigin = 'center center';
  logo.style.transition = 'none';
  logo.style.willChange = 'transform, opacity';

  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(updateLogo);
      ticking = true;
    }
  }, { passive: true });

  /* Initial state */
  updateLogo();
})();
